import React from 'react';

const ACTION_STYLES = {
  updated: 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  created: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
  skipped: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
  failed: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

const ACTION_LABELS = {
  updated: 'Aktualisiert',
  created: 'Neu angelegt',
  skipped: 'Übersprungen',
  failed: 'Fehler',
};

/** How the CMS matched an updated row to an existing listing. */
const MATCHED_VIA_LABELS = { slug: 'URL', name: 'Dateiname', number: 'Nummer' };

/**
 * Renders the per-file report the CMS returns. The endpoint never aborts a batch,
 * so a report mixes successes and failures — show every row.
 */
export function ImportResultList({ report }) {
  const { results = [], summary } = report || {};

  return (
    <div>
      {summary && (
        <div
          className={`rounded-xl px-4 py-3 mb-4 text-sm border ${
            summary.failed === 0
              ? 'bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-900/20 dark:border-emerald-800 dark:text-emerald-200'
              : 'bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-200'
          }`}
        >
          <strong className="block">
            {summary.failed === 0 ? 'Import abgeschlossen' : 'Import mit Fehlern abgeschlossen'}
          </strong>
          <span>
            {summary.created} neu · {summary.updated} aktualisiert · {summary.skipped} übersprungen ·{' '}
            {summary.failed} fehlgeschlagen
          </span>
        </div>
      )}

      <ul className="space-y-2 max-h-72 overflow-y-auto pr-1">
        {results.map((row) => (
          <li
            key={`${row.baseName}-${row.action}`}
            className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/60 px-3 py-2.5"
          >
            <div className="flex items-start justify-between gap-3">
              <span className="font-mono text-xs text-slate-600 dark:text-slate-300 break-all">
                {row.baseName}
              </span>
              <span
                className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${ACTION_STYLES[row.action]}`}
              >
                {ACTION_LABELS[row.action] || row.action}
              </span>
            </div>

            {row.jobTitle && (
              <p className="mt-1 text-sm text-slate-700 dark:text-slate-200">{row.jobTitle}</p>
            )}
            {row.matchedVia && (
              <p className="text-xs text-slate-500 dark:text-slate-400">
                zugeordnet über: {MATCHED_VIA_LABELS[row.matchedVia] || row.matchedVia}
              </p>
            )}
            {row.reason && (
              <p className="mt-1 text-xs text-amber-700 dark:text-amber-300">{row.reason}</p>
            )}
            {row.error && (
              <p className="mt-1 text-xs text-red-600 dark:text-red-400">{row.error}</p>
            )}
          </li>
        ))}
      </ul>

      <p className="mt-4 text-xs text-slate-500 dark:text-slate-400">
        Alle Stellen wurden als <strong>Entwurf</strong> gespeichert. Die Veröffentlichung erfolgt
        im CMS-Admin.
      </p>
    </div>
  );
}
